// 注文番号カウンタを保持する単一ドキュメントの場所。
// 採番はorderProduct(reducks/products/operations.js)のトランザクション内で行う。
export const ORDER_NO_COLLECTION = "order_no";
export const ORDER_NO_DOC_ID = "NhXvBeKknRdc5uZxIjW0";
